import { createAction } from 'redux-actions';

export const setLoadStorageValue = createAction('SET_LOAD_STORAGE_VALUE');
